import { FormControl, Grid, Input, InputLabel, Slider } from '@mui/material';
import React from 'react';

function SlideInput({ value, onChange, label, id }: any) {
  return (
    <FormControl
      sx={{
        width: '100%',
        px: 1,
        mt: 3,
        minHeight: 50,
      }}
    >
      <InputLabel
        shrink
        sx={{
          fontSize: '1.1rem !important',
          color: (theme) => `${theme.palette.text.primary} !important`,
          mt: -1,
        }}
      >
        {label}
      </InputLabel>
      <Grid container spacing={2} sx={{ alignItems: 'center' }}>
        <Grid>
          <Slider
            aria-label={id}
            defaultValue={value || 0}
            valueLabelDisplay="auto"
            step={0.01}
            min={0}
            max={1}
            onChange={(_, newValue) => onChange(newValue)}
          />
        </Grid>
        <Grid>
          <Input
            value={value || 0}
            size="small"
            onChange={(e) => onChange(e.target.value)}
            inputProps={{
              step: 0.01,
              min: 0,
              max: 1,
              type: 'number',
              'aria-labelledby': 'input-slider',
            }}
          />
        </Grid>
      </Grid>
    </FormControl>
  );
}

export default SlideInput;
